<template>
    <div ref="lyechartmain"  style="width: 100%;height: 280px"></div>
</template>

<script setup>
    import {onBeforeUnmount, onMounted, ref,nextTick} from "vue";
    // 按需引入echarts
    import echarts from "@/components/analysis/echartsInstall";
	import {systemDashList} from '@/api/api'
	import {FormatMoney} from "@/utils/util";
    let myChart = null
	var dataArr = [];
	var givenList=[];
	var GucciList=[];
	var burrberyList=[];
	var balenciaList=[];
	var kezonList=[];
	var hermesList=[];
	
    let option = {
        title: {
            text: ''
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#6a7985'
                }
            }
        },
        legend: {
            data: ['古驰', '纪梵希', '巴宝莉', '巴黎世家', '高田贤三','其他']
        },
        toolbox: {
            feature: {
              saveAsImage: {}
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: dataArr
            }
        ],
        yAxis: [
            {
              type: 'value'
            }
        ],
        series: [
            {
              name: '古驰',
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: GucciList
            },
            {
              name: '纪梵希',
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: givenList
            },
            {
              name: '巴宝莉',
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: burrberyList
            },
            {
              name: '巴黎世家',
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: balenciaList
            },
            {
              name: '高田贤三',
              type: 'line',
              stack: 'Total',
              label: {
                show: true,
                position: 'top'
              },
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: kezonList
            },
            {
              name: '其他',
              type: 'line',
              stack: 'Total',
              label: {
                show: true,
                position: 'top'
              },
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: hermesList
            }
        ]
     };
    let lyechartmain = ref(null)
	
    onMounted(() => {//需要获取到element,所以是onMounted的Hook
        getData()
		
		setTimeout(() => {
            nextTick(()=>{
                myChart = echarts.init(lyechartmain.value);
                myChart.setOption(option);
            })
        },3000)
         //myChart = echarts.init(document.getElementById("lyechartmain"));
        // // 绘制图表
         //myChart.setOption(option);
        window.onresize = function () {//自适应大小
            if(myChart){
                myChart.resize();
            }
        };
    });
    onBeforeUnmount(() => {
        window.onresize = null;
    })
	
	
	function getData(){
					
					
					
		            var data = new Date();
		            var year = data.getFullYear();
		            var month = data.getMonth() + 1;
		            var endDate = year - 1;	 //自定义截止年份时间 例如是2020年
		            var rate = year - endDate;
		            var monthNum = (rate - 1) * 12 + 11 + month;  //取到的月份	
					console.log(monthNum)
		            data.setMonth(data.getMonth() + 1, 1); //获取到当前月份,设置月份
					
					let monthArr=[]
					  systemDashList().then(res => {
						  
							
					      if (res.code == 2000) {
							  for (var i = 0; i < 12; i++) {
							    data.setMonth(data.getMonth() - 1); //每次循环一次 月份值减1
							    var m = data.getMonth() + 1;
								monthArr.push(m+"月")
							    m = m < 10 ? "0" + m : m;
							    dataArr.push(data.getFullYear() + "-" + m);
							    let nowDate=data.getFullYear() + "-" + m;
								let monthAmt=0

								
							    //月和品牌相同则push
							  
					          //tableData.value = res.data
							  res.data.forEach(function(data) {
								  
								  
								  
								
								if(data.saleMonth==nowDate&&data.brand=='Givenchy'){
										givenList.push(data.saleNum);
								}
								
								else if(data.saleMonth==nowDate&&data.brand=='Gucci'){
										GucciList.push(data.saleNum);
								}
								else if(data.saleMonth==nowDate&&data.brand=='Burberry'){
										burrberyList.push(data.saleNum);
								}
								else if(data.saleMonth==nowDate&&data.brand=='Kezon'){
										kezonList.push(data.saleNum);
								}
								else if(data.saleMonth==nowDate&&data.brand=='Balencia'){
										balenciaList.push(data.saleNum);
								}	
								else if(data.saleMonth==nowDate){
										hermesList.push(data.saleNum);
								}
							  });
							  
							  
							   // for (var i = 0; i < res.data.length; i++) {
								  //  if(res.data[i].saleMonth==nowDate&&res.data[i].brand=='Givenchy'){
									 //   givenList.push(res.data[i].saleNum);
								  //  }
								   
								  //  if(res.data[i].saleMonth==nowDate&&res.data[i].brand=='Gucci'){
									 //    GucciList.push(res.data[i].saleNum);
								  //  }
								  //  if(res.data[i].saleMonth==nowDate&&res.data[i].brand=='Burberry'){
									 //    burrberyList.push(res.data[i].saleNum);
								  //  }
							   // }
							  
							  
							  //  switch ( res.data) {
										
							  //         case res.data.saleMonth==nowDate&&res.data.brand=='Givenchy':
							  //           givenList.push(res.data.saleNum);
							  //         case  res.data.saleMonth==nowDate&&res.data.brand=='Gucci':
							  //           GucciList.push(res.data.saleNum);
							  //         case  res.data.saleMonth==nowDate&&res.data.brand=='Burberry':
							  //           burrberyList.push(res.data.saleNum);
							  //         case  res.data.saleMonth==nowDate&&res.data.brand=='Balencia':
							  //           balenciaList.push(res.data.saleNum);
									//   case  res.data.saleMonth==nowDate&&res.data.brand=='Hermes':
									//     hermesList.push(res.data.saleNum);
									//   case  res.data.saleMonth==nowDate&&res.data.brand=='Kezon':
									//   kezonList.push(res.data.saleNum);	
										
							  //       }
							 
					
							  //本月无数据则给0
							  if(givenList.length<i){
							  	 givenList.push(0)
							  }
							  if(GucciList.length<i){
							  	GucciList.push(0)
							  }
							  if(burrberyList.length<i){
							  	burrberyList.push(0)
							  }
							  if(balenciaList.length<i){
							  	balenciaList.push(0)
							  }
							  if(hermesList.length<i){
							  	hermesList.push(0)
							  }
							  if(kezonList.length<i){
							  	kezonList.push(0)
							  }
							}
							 console.log("givenList")
							 console.log(givenList)
							 
							 
							  localStorage.setItem('dataArr', monthArr)
							  
					      } else {
					          ElMessage.warning(res.msg)
					      }
					  })
					 
					  
		           

	}
	
    function handleResize() {
        if(myChart){
            myChart.resize();
        }
    }
    defineExpose({
        handleResize
    })
</script>

<style scoped>

</style>